export const translations = {
  en: {
    // Nav / Header
    dashboard:   'Dashboard',
    portfolio:   'Exchanges',
    bots:        'Trading',
    trading:     'Diary',
    admin:       'Admin',

    // Admin panel (base layer)
    adminConfig: 'App config',
    adminMaintenance: 'Maintenance mode',
    adminMaintenanceHint: 'When enabled, all users see the "Maintenance" screen and the API responds 503.',
    adminExchanges: 'Exchanges',
    adminExchangesHint: 'Show/hide exchanges in the app.',
    adminPayments: 'Payment methods',
    adminPaymentsHint: 'Show/hide payment networks for subscriptions.',
    adminFeatures: 'App sections',
    adminFeaturesHint: 'Enable/disable app sections.',
    adminBroadcast: 'Broadcast',
    adminBroadcastHint: 'Send a message to all users.',
    adminBroadcastTitle: 'Broadcast message',
    adminBroadcastPlaceholder: 'Message text…',
    adminBroadcastBtn: 'Send',
    adminBroadcastSending: 'Sending…',
    adminBroadcastConfirm: 'Send this message to all users? The bot will deliver it to each of them.',
    adminBroadcastDone: 'Broadcast started: {n} users',
    adminBroadcastNote: 'The message will appear in the bot chat of each active user.',
    adminNotifications: 'Admin notifications',
    adminNotifEnabled: 'Notifications enabled',
    adminNotifRegister: 'New registration',
    adminNotifPayment: 'Payment / renewal',
    adminNotifExpiry: 'Subscription expired',
    adminNotifChatId: 'Telegram chat / group ID',
    adminNotifChatPlaceholder: 'e.g. 123456789',
    adminSave: 'Save',
    adminSaved: 'Config saved',
    adminLoadError: 'Failed to load config',
    adminSaveError: 'Failed to save config',
    adminOnly: 'Admin only',
    adminSubs: 'Subscriptions',
    adminSubsHint: 'Find a user by ID, manage their subscription, verify payments by transaction hash.',
    adminSubsSearchTitle: 'Search user by ID',
    adminSubsSearchPlaceholder: 'User ID',
    adminSubsSearchBtn: 'Find',
    adminSubsNotFound: 'User not found',
    adminSubsUser: 'User',
    adminSubsSubActive: 'Subscription active',
    adminSubsSubInactive: 'No subscription',
    adminSubsPlan: 'Plan',
    adminSubsExpires: 'Until',
    adminSubsDemo: 'Demo',
    adminSubsHistory: 'Payment history',
    adminSubsHistoryEmpty: 'No payments yet',
    adminSubsExtendLabel: 'Extend (days)',
    adminSubsExtendBtn: 'Extend',
    adminSubsDaysPlaceholder: 'e.g. 30',
    adminSubsKindLabel: 'Account type for these days',
    adminSubsKindAuto: 'as now (keep type)',
    adminSubsKindReal: 'real account',
    adminSubsKindDemo: 'demo account',
    adminSubsCancelBtn: 'Cancel subscription',
    adminSubsCancelConfirm: 'Completely cancel this user\'s subscription? Their active payment requests will be closed.',
    adminSubsAddLabel: 'Add another subscription',
    adminSubsAddBtn: 'Add subscription',
    adminSubsActivateTitle: 'Manual activation',
    adminSubsActivateHint: 'Grant a tariff manually, e.g. after verifying payment via hash.',
    adminSubsSelectPlan: 'Plan',
    adminSubsVerifyTitle: 'Verify by transaction hash',
    adminSubsVerifyHint: 'Check on-chain that USDT arrived at one of our wallets. Optionally enter the recipient wallet address to narrow the search.',
    adminSubsNetwork: 'Network',
    adminSubsTxPlaceholder: 'Transaction hash',
    adminSubsAddrLabel: 'Wallet address',
    adminSubsAddrPlaceholder: 'Wallet address (optional)',
    adminSubsCheckBtn: 'Check hash',
    adminSubsCheckBusy: 'Checking…',
    adminSubsResultFound: 'Payment found',
    adminSubsResultNotFound: 'Payment not found',
    adminSubsResultAmount: 'Amount',
    adminSubsResultFrom: 'From',
    adminSubsResultTo: 'To',
    adminSubsResultConfirmed: 'Confirmed',
    adminSubsResultNote: 'Note',
    adminSubsConfirmActivate: 'Confirm subscription',
    adminSubsActivated: 'Subscription activated',
    adminSubsExtended: 'Subscription extended',
    adminSubsCancelled: 'Subscription cancelled',
    adminSubsError: 'Request failed',
    adminSubsPayPending: 'Pending',
    adminSubsPayPaid: 'Paid',
    adminSubsPayExpired: 'Expired',
    adminSubsPayFailed: 'Failed',
    adminSubsPayCancelled: 'Cancelled',
    adminStats: 'Statistics',
    adminStatsHint: 'Revenue, users and payment funnel.',
    adminUtm: 'UTM',
    adminUtmHint: 'UTM links and traffic sources.',
    statRevenue: 'Revenue',
    statRevenueTotal: 'Total revenue',
    statRevenueMonth: 'This month',
    statRevenueWeek: 'Last 7 days',
    // Показывается, когда в «Финансах» нажат сброс статистики: выручка тоже
    // считается от метки сброса (см. resetFinanceStats в TG-BOT/src/db.js).
    statRevenueReset: 'Counted since the Finance stats reset: {at}',
    statByPlan: 'By plan',
    statByNetwork: 'By network',
    statCountSuffix: 'payments',
    statUsers: 'Users',
    statUsersTotal: 'Total registered',
    statUsersActive: 'Active now',
    statSeenToday: 'Active today',
    statSeen7d: 'Active 7 days',
    statSeen30d: 'Active 30 days',
    statWithApiKeys: 'Connected exchange (API keys)',
    statWithBots: 'Created bots',
    statOnDemo: 'On demo account',
    statOnReal: 'On real account',
    statFunnel: 'Viewed, but didn’t pay',
    statViewedApp: 'Viewed app / bot',
    statNotReachedPayment: 'Entered, never reached payment',
    statStartedNotPaid: 'Started payment, didn’t pay',
    statEverPaid: 'Paid at least once',
    statNoSubscription: 'Currently without subscription',
    utmGenerator: 'Link generator',
    utmGenHint: 'Pick source, channel and campaign — get a ready-made link to share. Users who open it land in the stats below.',
    utmSource: 'Source (utm_source)',
    utmSourcePlaceholder: 'telegram, google, partner…',
    utmMedium: 'Channel (utm_medium)',
    utmMediumPlaceholder: 'cpc, banner, referral…',
    utmCampaign: 'Campaign (utm_campaign)',
    utmCampaignPlaceholder: 'launch, friend…',
    utmLinkTelegram: 'Link for Telegram',
    utmLinkWeb: 'Web link',
    utmCopy: 'Copy',
    utmCopied: 'Copied ✓',
    utmOpen: 'Open',
    utmBotHint: 'Bot: {name} — links are built for it. If the bot is ever renamed, they update automatically.',
    utmGenNote: 'The Telegram link opens the bot and carries the tags inside the start parameter — paste it into YouTube descriptions, posts, chats or ads. The web link is for sites and direct traffic.',
    utmStats: 'Traffic stats',
    utmTotal: 'Users with tags',
    utmBySource: 'By source',
    utmByCampaign: 'By campaign',
    utmSubscribers: 'subscribed',
    utmRecent: 'Recent entries',
    utmRecentEmpty: 'No tags yet — nobody has opened the app via a UTM link.',
    utmInternalNote: 'Internal accounts (the owner and the “user mode” test account) are not counted here — their own visits are excluded from the stats.',
    utmError: 'Failed to load UTM stats',
    utmDynamics: 'Daily dynamics',
    utmDynHint: 'Users who arrived with tags over the last {days} days and how many of them paid.',
    utmDynUsers: 'arrived',
    utmDynPaid: 'paid',
    utmByMedium: 'By channel (utm_medium)',
    utmDynEmpty: 'No data for this period yet.',
    utmTerm: 'Term (utm_term)',
    utmTermPlaceholder: 'keywords, ad set…',
    utmContent: 'Content (utm_content)',
    utmContentPlaceholder: 'banner, post, video…',
    utmPresets: 'Quick presets',
    utmPresetTg: 'Telegram',
    utmPresetGoogle: 'Google',
    utmPresetFb: 'Facebook',
    utmPresetIg: 'Instagram',
    utmPresetTt: 'TikTok',
    utmPresetPartner: 'Partner',
    utmByEntry: 'By entry point',
    utmRevenue: 'revenue',
    utmRevenueTotal: 'Revenue from tagged users',
    utmDays: '{days} days',
    supportCooldown: 'You already sent a request. You can send the next one in {min} min.',
    maintenanceTitle: 'Maintenance in progress',
    maintenanceText: 'We are doing some work on the service. Please come back in a few minutes.',

    // UserProfile
    subscriptionUntil: 'Subscription until:',
    subscriptionInactive: 'Subscription inactive',
    adminNoExpiry: 'Admin · no expiry',
    userFallback: 'User',
    subscription: 'Subscription',
    extendSubscription: 'Renew subscription',
    subscriptionSelectPlanDesc: 'Choose a subscription plan that suits you best:',
    // Юридические дисклеймеры (Волна 0.3, 2026-08-31): риск-дисклеймер на
    // экране подписки, «не финансовый совет» + ToS/Privacy + 18+ в футере.
    legalFooter: 'Not financial advice · 18+',
    legalTerms: 'Terms',
    legalPrivacy: 'Privacy',
    legalTitle: 'Legal Information',
    legalRiskDisclaimer: 'Cryptocurrency trading involves a high level of risk. The bot does not guarantee profit. You may lose your entire deposit.',
    legalNotFinancialAdvice: 'This is not financial advice. The service is provided for informational purposes only. Nothing in this app is a recommendation to buy or sell any asset.',
    legal18Plus: 'This app is intended for users aged 18 and over. By continuing to use the service you confirm that you are at least 18 years old.',
    legalTosTitle: 'Terms of Service',
    legalTosBody: '• The service provides trading bots that collect funding on crypto exchanges.\n• By using the service you accept the risks of cryptocurrency trading and are fully responsible for your funds.\n• You are responsible for the safety of your API keys and of the funds on the exchange.\n• The administration may modify or discontinue the service with prior notice.\n• Any abuse of the service or unauthorized access attempts are prohibited.',
    legalPrivacyTitle: 'Privacy Policy',
    legalPrivacyBody: '• We process only the minimum necessary data: your Telegram ID, name and app settings.\n• Your exchange API keys are stored encrypted and used only for trading.\n• We do not share your personal data with third parties, except as required by law.\n• You can request deletion of your data via support.',
    // API-key security block (task.txt, 2026-09-16): reassuring facts about how
    // the app handles exchange keys — every bullet is true in the code.
    legalSecurityTitle: 'API Key Security',
    legalSecurityBody: '🔐 Keys are encrypted with AES-256-GCM as soon as they are saved — they are never stored in plaintext anywhere.\n🕶 The full key is never shown in the app — you only see a mask (the first and last 4 characters).\n🧠 Keys are decrypted only in the memory of the trading process, for the duration of a trade, and are never written to disk or logs.\n👤 The administration never sees your keys in plaintext — the full key is not available even in the admin panel.\n🗑 You can delete your keys at any time: the bot stops trading and your stored keys are removed.\n🔒 Keys give access ONLY to futures trading on the exchange — trading API keys have no withdrawal permission, so withdrawing funds from your account with such keys is impossible.\n🔀 Keys of each exchange are isolated: Bybit keys are used only for Bybit trades, Binance keys only for Binance, Bitget keys only for Bitget.\n⏳ Keys are used exclusively at the moment of a trade (placing an order, monitoring the position, closing it) and for nothing else.\n🧹 Deleting a key instantly erases it (and the passphrase, if set) from the database — after deletion the key cannot be restored.',
    // Referral program terms — shown in the «Legal» (bottom of the app), after Privacy.
    legalReferralTitle: 'Referral program',
    legalReferralBody: '• You invite friends with your personal link.\n• You earn 10% of the amount of your friend\'s FIRST paid subscription.\n• A “friend” is a new user who has never paid for a subscription before. Each friend counts once.\n• Rewards accumulate in USD and are paid out manually by the 5th of the month following the friend\'s payment.\n• You cannot invite yourself.\n• The administration may change or terminate the program at any time.',
    // Онбординг первого входа (п.0.3, 2026-08-31): 3 экрана → пробный бот.
    onbTitle: 'The trading bot collects funding payouts: every 8 hours — and every hour on some coins',
    onbSubtitle: 'Free trial bot: no API keys and no subscription needed. It trades on real market data — your first 2 trades are on us.',
    onbCta: 'Try for free',
    onbLater: 'Later',
    onbCreating: 'Creating your trial bot...',
    onbCreatingHint: 'It is free and takes just a few seconds',
    onbCreateFailed: 'Failed to create the trial bot. Please try again.',
    onbRetry: 'Retry',
    trialStatusTitle: 'Trial bot',
    trialStatusStartDesc: 'Your trial bot is ready. Start it to begin catching funding payouts.',
    trialStatusStart: 'Start',
    trialStatusRunning: 'Trial bot is running and waiting for the funding payout',
    trialStatusWaiting: 'The bot is waiting for the funding payout. As soon as the payout arrives, the bot enters a trade.',
    trialStatusViewBot: 'Open bot',
    planDemo: 'Demo account (1 month)',
    plan1Month: 'Real account (1 month)',
    plan3Months: 'Real account (3 months)',
    plan6Months: 'Real account (6 months)',
    continue: 'Continue',
    back: 'Back',
    completePayment: 'Complete payment',
    subscriptionSendPaymentDesc: 'Send the exact amount to the address below:',
    amountToSend: 'Amount to send',
    walletAddress: 'Wallet address',
    copy: 'Copy',
    copied: 'Copied!',
    subscriptionWarning: 'Important: Send only the specified currency on the specified network. Sending other assets may result in permanent loss.',
    confirmPayment: 'I have sent the payment',

    // Subscription payment (real crypto flow)
    createPayment: 'Create payment',
    creatingPayment: 'Creating payment…',
    paymentExpiresIn: 'Payment is valid for 20 minutes',
    paymentWindowLeft: 'Time left',
    paymentPending: 'Waiting for payment…',
    checkPayment: 'Check payment',
    paymentConfirmed: '✅ Payment confirmed!',
    paymentActivated: 'Subscription is now active.',
    paymentExpired: '⏰ Payment time has expired. Please create a new payment.',
    paymentCreateFailed: 'Failed to create payment.',
    noFreeAddress: 'No free receiving address for this network right now. Please choose another network or try later.',
    rateUnavailable: 'Exchange rate is temporarily unavailable. Please try again in a few minutes.',
    planRealHint: 'Includes demo account access',
    planDemoHint: 'Demo account only',
    planIncludesArb: 'Includes arbitrage bot',
    cancelPayment: 'Cancel payment',

    cancel: 'Cancel',
    cancellingPayment: 'Cancelling…',
    cancelPaymentConfirmTitle: 'Cancel payment?',
    cancelPaymentConfirmMsg: 'If you have already sent funds to this address, they will not be credited. Cancel anyway?',
    cancelPaymentFailed: 'Failed to cancel payment.',
    paymentChecking: 'Checking payment…',
    paymentStillPending: 'Payment not found on the network yet. It usually appears within a few minutes — please wait, the check will continue automatically.',
    paymentCheckFailed: 'Payment check failed. Please try again in a moment.',
    paymentCheckFailedDetail: 'Payment check failed: {error} Please try again in a moment.',
    processingTitle: 'Payment in progress',
    processingCheck: 'We are checking the arrival of your payment on the network. This usually takes up to a minute — please wait.',
    processingCancelHint: 'Cancel will close this window and return you to the payment step.',
    closeWindowConfirmTitle: 'Close this window?',
    closeWindowConfirmMsg: 'You will return to the payment step. The payment request stays active and the check continues.',
    closeWindow: 'Close',
    subInfoAmount: 'Amount',
    subInfoNetwork: 'Network',
    subInfoPlan: 'Plan',
    subInfoValidUntil: 'Valid until',
    supportContact: 'Contact support',
    supportExpired: 'The payment window has expired. If you have already sent the payment — write to support and we will check it.',
    supportTitle: 'Contact support',
    supportIntro: 'Choose an issue or describe it — the message will be sent automatically to our support chat.',
    supportOpt1: 'I paid, but the payment was not credited',
    supportOpt2: 'Question about the subscription (plan, renewal, payment)',
    supportOpt3: 'Something else',
    supportPlaceholder: 'Describe the issue… (optional)',
    supportSend: 'Open Telegram and send',
    supportCopied: 'Message copied — paste it into the chat and send.',
    supportMsgHello: 'Hello! I have an issue with the subscription payment:',
    supportMsgUser: 'User',
    supportMsgRequest: 'Payment request',
    supportMsgAddress: 'Address',
    supportMsgAmount: 'Amount',
    supportMsgProblem: 'Issue',
    supportMsgDetails: 'Details',
    supportMsgGeneralHello: 'Hello! I have a question for support:',
    supportSending: 'Sending…',
    supportSentOk: '✅ Message sent! Support will reply in the SCALPEX bot chat.',
    supportSendFail: '⚠️ Could not send. Try again or write to the support chat directly.',

    // Time period tabs
    periodDaily:   'Daily',
    periodWeekly:  'Weekly',
    periodMonthly: 'Monthly',
    periodTotal:   'Total',

    // Stats cards
    statToday:      'Today',
    statYesterday:  'Yesterday',
    statDifference: 'Difference',

    // KPI
    tradingStats:     'Trading Statistics',
    kpiWinRate:       'Win Rate',
    kpiTotalTrades:   'Total Trades',
    kpiAvgProfit:     'Avg. Profit',
    kpiProfitFactor:  'Profit Factor',
    kpiMaxDrawdown:   'Max Drawdown',
    kpiTopAssets:     'Top 3 Assets',

    // Profit section
    profit: 'Profit',

    // Profit section tooltip
    profitTooltip: 'Shows realized profit / loss — only closed positions are counted in the statistics.',

    // Settings modal
    settingsTitle:      'Settings',
    languageLabel:      'Language',
    notificationsLabel: 'Notifications',
    save:               'Save',

    // Referral program (п.4.4 ПЛАН_МАРКЕТИНГА) — block in Settings + terms in Legal
    settingsReferralLabel: 'Referral program',
    referralInviteTo:      'Invite a friend — earn 10% of their first paid subscription.',
    referralLinkLabel:     'Your invite link',
    referralFriendsInvited:'Friends invited',
    referralTotalEarned:   'Total earned',
    referralEarnedMonth:   'Earned this month',
    referralPayoutNote:    'Rewards are paid out manually by the 5th of the following month.',
    referralDue:           'To be paid out',
    referralNoFriends:     'No earnings yet — share your link and earn 10% of a friend\'s first subscription.',
    referralTerms:         'Program terms',
    referralLoading:       'Loading…',

    // Onboarding hints (tour)
    hintsLabel:          'Hints',
    hintsDesc:           'Walk you through the app on first launch. Turn back on to see the tour again.',
    welcomeHintTitle:    'Getting-started hints',
    welcomeHintText:     'SCALPEX automates funding sniping (funding collection) on exchanges: the algorithm finds profitable funding rates and opens trades automatically. Start with a free trial bot — it will show you the strategy without any API keys.',
    welcomeHintCreateBot: 'Create a trial bot',
    welcomeHintStart:    'Start the tour',
    welcomeHintDismiss:  'You can turn hints off in Settings',
    hintStep4Title:      'Trial bot',
    hintStep4Text:       'Tap "Add bot" — if you are a new user, a free trial bot is created right away: 2 trades on virtual money, no API keys needed. It will show you how the strategy works.',
    hintStep8Title:      'Full user guide',
    hintStep8Text:       'The full guide is always at hand — Settings (gear icon) → User Guide. Hints are short; look there for details. Now let us create a trial bot.',
    hintDoneTitle:       'You are all set!',
    hintDoneText:        'The trial bot is created and already trading on virtual money — watch the results in the Diary. After 2 trades you can take out a subscription to switch to a demo or real account.',
    hintNext:            'Next',
    hintSkip:            'Skip',
    hintDoneBtn:         'Done',
    hintDisable:         'Turn off hints',

    // Instruction (user guide)
    instructionTitle:    'User Guide',
    instructionSubtitle: 'How to use the bot',
    instructionClose:    'Close',
    instructionError:    'Failed to load the user guide',
    instructionRetry:    'Retry',
    instructionUpdated:  'Updated',
    welcomeHintGuide:    'Full user guide',

    // API-keys guide (button in the instruction, Step 2)
    guideApiKeysTitle: 'How to get exchange API keys?',
    guideApiKeysError: 'Failed to load the guide',
    guideApiKeysRetry: 'Retry',
    guideApiKeysClose: 'Close',

    // Instruction image fallback (Markdown.jsx)
    imgScreenshot: 'Screenshot',
    imgNotUploaded: 'file not uploaded to the server yet',

    // Exchanges page
    exchangeTitle:   'Exchange Connection',
    exchangeDesc:    'Connect an exchange via API for automated bot trading',
    connected:       'Connected',
    notConnected:    'Not connected',
    connect:         'Connect',
    disconnect:      'Disconnect',
    collapse:        'Collapse',
    securityNote:    'Enable "Read" and "Trade" on the key. Do not enable "Withdrawal".',
    // 2026-09-27, task.txt: ссылка на гайд прямо из формы ключей.
    keysGuideLink:   'How to get the keys and which permissions to enable?',
    confirmConnect:  'Confirm connection',
    realAccountApi:  'Real Account API',
    demoAccountApi:  'Demo Account API',

    // Bitget passphrase (2026-09-17, task.txt п.3): Bitget API v2 signs every
    // request with the passphrase — a required field for this exchange only.
    bitgetPassphrase:         'Passphrase (required for Bitget)',
    bitgetPassphrasePlaceholder: 'Saved (leave as is to keep it)',
    bitgetPassphraseHint:     'Bitget API v2 requires a passphrase (set in exchange → API → Create API Key). Without it the keys will not be saved. 8–64 characters, letters/digits only.',

    // Notifications items
    tradingSignals:     'Trading Signals',
    tradingSignalsDesc: 'Notify when your bot closes a trade',
    // п.8 task.txt: уведомления о фандингах за 5 минут до выплаты
    fundingNotifications:     'Funding notifications',
    fundingNotificationsDesc: 'Notify 5 minutes before a funding payout',

    // QuickActions
    myBots: 'My Bots',
    newBot: 'New Bot',

    // Bots page — tabs & actions
    botsSpot:         'SPOT',
    botsFutures:      'FUTURES',
    botsDisableAll:   'Disable All',
    botsAddBot:       'Add Bot',
    botsNoBots:       'No active bots',
    botsNoBotsDesc:   'Add your first bot to start automated trading',
    botsNoBotsHint:   'Add your first bot to start automated trading',
    // ── Пробный виртуальный бот (Волна 1, 2026-08-28) ──
    virtualBadge:            'TRIAL',
    virtualCreateHint:       'Free trial bot · 2 trades, no API keys needed',
    virtualTrialFinishedTitle: 'Free trial finished',
    virtualTrialFinishedDesc: 'Your trial bot has used its 2 free trades. Subscribe to continue trading — demo or real account.',
    virtualSubscribeBtn:     'Choose subscription',
    virtualTrialCardHint:    'Demo of the strategy — the bot trades virtual money.',
    botsInDev:        'In Development',
    botsInDevDesc:    'Arbitrage bots are coming soon. Stay tuned!',
    botsExchangeTaken:'Bot already exists for this account',
    botsExchangeUnavailable:'This exchange is unavailable for new bots',
    botsPairTaken:    'A bot for this pair already exists',
    createDemoBot:    'Create Demo Bot',
    createRealBot:    'Create Real Bot',
    botsAllCreated:   'You already have bots for every available account type on every exchange',
    botsNoSubscriptionHint: 'You have reached the bot limit for your subscriptions. To create another bot, activate a subscription for the other account type.',

    // Bot toggle
    botToggleOn:     'ON',
    botToggleOff:    'OFF',
    // Подписка истекла — ползунок заблокирован, нажатие показывает это уведомление
    botSubExpired:   'Your subscription has expired. Renew it in the "Subscription" section to run the bot again.',
    botSubExpiredBanner: 'Your subscription has expired — bots are stopped. Renew to enable them.',

    // Bot card info rows
    botType:         'Bot type',
    botBalance:      'Working Volume',
    botClosedTrades: 'Closed trades',
    botCommission:   'Exchange commission',
    botProfit:       'Trade profit',
    botStatus:       'Status',
    botStatusActive: 'Active',
    botStatusPaused: 'Paused',
    botOpenPos:      'Open positions',
    botCreated:      'Created',
    botExchange:     'Exchange',

    // Понятная юзеру ошибка по боту. Категорию (kind) присылает бэкенд
    // (botHealth) в поле problem — тексты живут здесь, чтобы работали оба
    // языка. Юзеру не показываем ни кодов биржи, ни её JSON: только эти фразы.
    botProblemVolume:        'Trade volume error',
    botProblemVolumeAdvice:  'The exchange rejects the trades: the volume is too big for the money on your trading account. Lower the volume or top up the trading account.',
    botProblemNoFunds:       'Not enough money on the trading account',
    botProblemNoFundsAdvice: 'Move money from the funding account to the trading account inside the exchange (guide, Step 3) — or lower the trade volume / leverage in the bot settings. The bot opens several trades at once, so the free margin has to cover all of them.',
    botProblemApiKey:        'API key problem',
    botProblemApiKeyAdvice:  'Check the key: trading permission and IP address (guide, Step 2).',
    botProblemSymbol:        'Coin problem',
    botProblemSymbolAdvice:  'The coin is unavailable or the volume is below the exchange minimum. The bot will try other coins.',
    botProblemOther:         'The exchange rejects the trades',
    botProblemOtherAdvice:   'Check the money on your trading account and the bot settings.',

    // Bot delete flow
    botStopFirst:    'Stop the bot before deleting',
    botConfirmDel:   'Delete this bot?',
    botConfirmDelMsg:'If there are open positions, the bot will close them immediately before deleting itself.',
    botDelete:       'Delete',
    botCancel:       'Cancel',
    botNameExists:   'A bot with this name already exists',

    // Exchanges
    edit:            'Edit',
    delete:          'Delete',
    editApiKeys:     'Enter new API keys to update connection',
    saveChanges:     'Save Changes',

    // Diary
    diaryTotalIncome:'Total Income',
    diaryClearConfirmTitle: 'Clear diary?',
    diaryClearConfirmMsg: 'All bots must be deleted before clearing the diary.',
    diaryClearAction: 'Clear',
    diaryClearCancel: 'Cancel',

    // Add bot modal
    addBotTitle:      'Add Bot',
    addBotName:       'Bot name',
    addBotNamePh:     'My Bot',
    addBotNameEn:     'Bot name — English letters, digits and spaces only',
    addBotExchange:   'Exchange',
    addBotVolume:     'Available Balance (USDT)',
    addBotAlgoTitle:  'Algorithm Parameters',
    addBotLeverage:   'Leverage',
    addBotOrders:        'Number of Fundings',
    orderLabel:          'Order',
    addBotOrderOffset:   'Offset (%)',
    addBotOrderVolume:   'Volume (USDT)',
    addBotTakeProfit:    'Take Profit (%)',
    tooltipTakeProfit:   'Take Profit here is not a profit target — it is simply an exit point. It is set as small as possible to exit the position quickly after the funding payout: the point of the strategy is to collect the funding and close without losing on price movement.',
    // SHORT-режим: тейк-профит — уровень падения цены ниже фандинга (task.txt).
    // При фандинге −1% цена должна упасть на 1% (покрыть нашу выплату), всё ниже — прибыль.
    // Итог = 1% (выплата фандинга) + 0.3% (наш тейк-профит) = 1.3%.
    tooltipTakeProfitShort: 'In SHORT mode the take-profit is the level the price must fall below after the funding payment. If the funding is −1%, the price must drop by 1% (to cover our funding payment) — everything below that is our profit. Result: take-profit = 1% (funding payment) + 0.3% (our profit) = 1.3%.',
    addBotStopLoss:      'Stop Loss (%)',
    tooltipStopLoss:     'Stop Loss is the loss you may take if the situation does not work out as planned. It acts as insurance against unexpected price movement.',
    addBotLaunch:        'Launch Bot',
    addBotBlacklistTitle:'Pair Blacklist',
    addBotBlacklistDesc: 'Pairs in the list will not be processed by the Bot',
    addBotBlacklist:     'Ignored Pairs',
    addBotBlacklistPh:   'Search pair (e.g. BTCUSDT)...',
    tooltipOrders:       'The number of funding rates the bot will collect. If set to 3 and three funding rates match the filter, a position is opened for each one and all of them are collected.',
    addBotGlobalVolume:  'Volume (USDT)',
    tooltipGlobalVolume:      'The volume is set for one trade on one funding (one payout collection).',
    tooltipGlobalVolumePart2: 'If the number of fundings is 3, the bot uses this same volume for each trade separately — the amount you set is applied to each funding.',
    addBotVolumeMin:     'Minimum volume is 10 USDT',
    addBotMinFunding:    'Min. Funding Rate',
    tooltipMinFunding:   'The bot filters funding rates: the value is an upper bound. Only coins with a funding rate NOT ABOVE it are traded. The minus sign is already in the field — just type the number: 0.6 means -0.6% (the more negative the rate, the bigger the payout for a long).',
    addBotMaxFunding:    'Max. Funding Rate',
    tooltipMaxFunding:   'Optional. Lower bound of the funding rate: coins with a rate BELOW this value are NOT traded. The minus sign is already in the field — type 1.0 to mean -1.0% and trade only rates between -1.0% and your minimum rate. Leave empty for no lower limit.',
    addBotTradingMode:   'Trading Mode',
    tradingModeDesc:     'Custom mode is for those who understand the algorithm and the strategy well — you can experiment and adjust various parameters. It is not recommended for regular users: everything is already set so the bot trades in profit.',
    addBotTradeDir:      'Trade direction',
    recommendedMode:     'Recommended',
    tradeModeLong:       'Long · funding',
    tradeModeShort:      'Short · drop',
    tradeModeLongDesc:   'The bot opens a LONG position before the funding payment and takes the payment itself: at a deeply negative rate (≤ −0.6%) shorts pay the longs. Classic funding-harvesting mode.',
    tradeModeShortDesc:  'The bot opens a SHORT position and takes the move (drop/pullback) that happens after the funding payment. Full explanation — in the instruction.',
    tradingModeSafe:     'Custom',
    tradingModeAggressive: 'Aggressive',

    // task.txt №3 (2026-09-04): одноразовое уведомление о смене рекомендуемого
    // режима (появляется по центру, показывается один раз на каждую смену).
    modeNoticeTitle:     'Recommended mode for bots',
    modeNoticeTextShort: 'Volatility is up and the market is moving lower. For current conditions, we recommend SHORT mode.',
    modeNoticeTextLong:  'Conditions are now favorable for collecting funding payouts. We recommend LONG mode.',
    modeNoticeDismiss:   'Got it',

    // Bots main tabs
    botsTabSignals:    'Signals',
    botsTabActiveBots: 'Active Bots',
    botsTabConfig:     'Configuration',

    // Signals
    signalPinned:          'PINNED',
    signalsComingSoon:     'No Signals',
    signalsComingSoonDesc: 'No pairs match your current configuration. Try adjusting the time window or minimum funding rate.',
    signalLaunched:        'Bot Added!',
    signalNoResults:       'No signals',
    signalNoResultsDesc:   'No pairs match the current filter. Adjust the time or minimum rate in Configuration.',
    signalsLoadError:      'Failed to load signals. Check connection.',

    // ── Hardcoded strings moved to i18n (2026-08-05) ──
    timeMin: 'm',
    timeHour: 'h',
    loading: 'Loading...',
    creating: 'Creating...',
    processing: 'Processing...',
    connectionError: 'Connection error',
    alertErrorPrefix: 'Error',
    unknownError: 'Unknown error',
    funding: 'Funding',
    accountMode: 'Account mode',
    realKeysLocked: '🔒 Real account keys require a "Real account" subscription',
    demoKeysLocked: '🔒 Demo account keys require an active subscription',
    realAccountLocked: '🔒 Real account requires a "Real account" subscription',
    demoAccountLocked: '🔒 Demo account requires an active subscription',
    // Слот бота — пара «тип счёта × биржа» (2026-09-20): демо-бот на Bybit не
    // мешает создать демо-бота на Binance, поэтому подпись говорит, НА КАКОЙ
    // бирже слот занят ({exchange} подставляется в AddBotModal), а отдельная
    // строка — случай, когда заняты все биржи.
    demoBotExists: '🔒 A demo bot already exists on {exchange} — pick another exchange',
    realBotExists: '🔒 A real bot already exists on {exchange} — pick another exchange',
    demoBotAllExchanges: '🔒 A demo bot already exists on every exchange — delete it to create a new one',
    realBotAllExchanges: '🔒 A real bot already exists on every exchange — delete it to create a new one',
    tradingModeCustom: 'Custom',
    tradingModeSystem: 'System',
    initEnv: 'Initializing (~4 min)',
    initProgress: 'Initializing...',
    noApiKeysHint: '🔑 Connect exchange API keys in "Exchanges" first',
    botsLimitReached: 'Bot limit reached ({n}/{n})',
    botsLoadError: 'Failed to load bots. Check connection.',
    signalLaunchError: 'Failed to create bot. Check connection.',
    configSaveError: 'Failed to save config',
    blacklistSaveError: 'Failed to save blacklist',
    inDevelopment: 'In development',
    soon: 'Soon',
    networkSelectTitle: 'Select network',
    selectNetworkForUsdt: 'Select network for USDT:',
    notViaTelegram: '❌ The app is not opened via Telegram — window.Telegram.WebApp is unavailable',
    // Telegram Stars — «Покупка в один клик» (план 2026-09-05). Наценки нет;
    // строка о комиссии Telegram юзеру НЕ показывается (решение владельца).
    starsQuickTitle: 'One-tap purchase',
    starsQuickDesc: 'Fast, convenient payment',
    starsBuy: 'Pay {stars} ⭐ in one tap',
    starsPaid: 'Subscription active 🎉',
    starsProcessing: 'Paying…',
    starsActivating: 'Paid — activating subscription',
    starsInvoiceError: 'Could not open the invoice. Try again.',
    starsNotInTelegram: '⭐ Star payments work only inside Telegram — open the mini app from the bot.',
    webLandingTitle: 'SCALPEX — a bot that earns on funding rates',
    webLandingSub: 'Finds suitable funding rates on Bybit and trades for you right in Telegram. Try it free.',
    webLandingBtn: 'Open in Telegram',
    webLandingHint: 'The mini app opens right inside Telegram — no install needed.',
    noUserId: '❌ Could not determine the user ID. Try restarting the bot.',
    paymentSimulated: '✅ Payment simulated! Your ID has been added.',
    testPaymentBtn: '🧪 Test payment (Add to allowed_users)',
    deleteError: 'Deletion error',
    confirmDeleteKeys: 'Are you sure you want to delete the saved keys?',
    keysDeleted: '✅ Keys deleted successfully',
    integrationInDev: '🔧 Integration with {ex} is under active development.\nFollow the updates — connection will be available in upcoming versions.',
    deleteBotToEditKeys: 'Delete this exchange\'s bot to change keys',
    subscriptionRequiredConnect: 'To connect an exchange you need an active subscription. Press "Test payment" in the "Subscription" section.',
    diaryTotalPct: 'Total %',
    real: 'Real',
    demo: 'Demo',
    refreshData: 'Refresh data',
    diaryClearNeedDeleteBots: 'Delete all bots before clearing the diary',
    leaderboardTitle: '🏆 Leaderboard',
    leaderboardDays: '{n} d.',
    // Метка своей строки: имена на доске — псевдонимы (TG-BOT/src/nickMask.js),
    // без метки юзер не узнает себя.
    leaderboardYou: 'You',
    // Прибыль юзера ЗА 7 ДНЕЙ — ровно то окно, по которому считает доска
    // (v6-week7, task.txt 2026-09-10), а не разовый PNL с одной сделки.
    leaderboardTotalPnl: 'P&L over 7 days',
    // Депозит участника (п.25 task.txt). п.9 task.txt (2026-09-17): подпись
    // «deposit»+цифра были непонятны — теперь это отдельный чип с явной меткой
    // «Deposit» и жирным значением рядом (label + value в одной строке).
    leaderboardDepositLabel: 'Deposit',
    // FOMO-блок над доской (п.11 task.txt): сколько виртуальные юзеры
    // лидерборда заработали сегодня + мини-лента последних сделок.
    fomoTitle:  '🔥 Traders earned today',
    fomoRecentEarned: 'earned {x}',
    // П.2 task.txt: когда сегодня плюсовых PNL нет — блок показывает «вчера»,
    // чтобы над доской всегда была ненулевая цифра + лента вчерашних сделок.
    fomoYesterdayTitle: '🔥 Traders earned yesterday',
    // Счётчик «уже заработали сегодня» (п.28 task.txt): серая строка на Главной
    // с ротацией имён. Сумма рисуется рядом жирным (в компоненте), earnedToday —
    // только подпись до неё; {name}/{x} подставляются форматированными
    // значениями (имя частично замаскировано, x — сумма с «$»).
    earnedToday:   'Already earned today: ',
    earnedTodayBy: '{name} {x}',
    // П.3 task.txt: когда сегодня нет плюсовых PNL — показываем «вчера заработали»,
    // чтобы строка всегда была заполнена ненулевой суммой.
    earnedYesterday:   'Earned yesterday: ',
    earnedYesterdayBy: '{name} {x}',

    // Config tab
    cfgTimeLabel:   'Time Before Funding',
    cfgTimeDesc:    'Show only pairs where the next funding charge is within the selected time window.',
    cfgExchangeLabel: 'Exchange',
    filterUntil:      'Until funding',
    filterMinRate:    'Min. rate',
    filterPairs:      'Pairs',
    cfgSaved:         'Saved!',

    // Bots (legacy)
    activeBots: 'Active Bots',
    botsComingSoon: 'My Bots',

    // Diary (closed positions)
    diaryEmpty:      'No closed positions yet',
    diaryLong:       'Long',
    diaryShort:      'Short',
    diaryEntry:      'Entry',
    diaryExit:       'Exit',
    diaryDuration:   'Duration',
    diaryClosedAt:   'Closed',
    diarySize:       'Volume (USDT)',
    diaryCommission: 'Commission',
    diaryRoi:        'ROI',

    // Chart
    monthNames:    ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    chartProfit:   'Profit',
    chartTrades:   'Trades',
    chartVolume:   'Volume',
    chartWinRate:  'Win Rate',
    chartAvgPnl:   'Avg. PnL',
    chartNoData:   'No data for this period yet',

    // ComingSoon / Error
    comingSoon:      'Coming soon',
    maintenance:     'Maintenance',
    maintenanceDesc: "We're fixing things. Back to normal soon.",
    tryAgain:        'Try again',

    // Boot (п.3 task.txt: понятный экран вместо пустого экрана при сбое загрузки)
    bootSdkFailed:     'Could not connect to Telegram',
    bootSdkFailedHint: 'Check your internet connection and open the app again.',
    bootLoadFailed:    'Could not load your data',
    bootLoadFailedHint:'Check your internet connection and tap "Try again".',

    // Fortune wheel (owner task 2026-10-19). The first window is a small
    // centered notice with the "Claim prize" button; it opens the wheel.
    fortuneIntroTitle: 'Bonus giveaway',
    fortuneIntroText: 'We give bonuses to active SCALPEX users. Spin the wheel — prizes from $0.50 to $30 in Telegram Stars and 1 to 42 days of subscription.',
    fortuneIntroTake: 'Claim prize',
    fortuneTitle: 'Fortune wheel',
    fortuneIntroHint: 'The button charges nothing — Stars are charged only after you confirm in Telegram.',
    fortuneTierBase: 'Basic',
    fortuneTierMid: 'Medium',
    fortuneTierAdv: 'Advanced',
    fortuneSpinPrice: 'Spin price',
    fortuneSpin: 'Spin',
    fortuneSpinFor: 'Spin for {stars} ⭐',
    fortuneSpinAgainFor: 'Spin again · {stars} ⭐',
    // Админ крутит без списания звёзд (решение владельца 2026-10-21): путь тот
    // же, что у юзера, включая окно оплаты Telegram, но оплата не проходит.
    fortuneFreeError: 'Could not start the free spin. Try again.',
    fortuneApprox: '≈ ${usd}',
    fortunePrizesTitle: 'Prizes',
    fortunePrizeDemo: 'Demo subscription',
    fortunePrizeReal: 'Real subscription',
    fortunePrizeDays: '{days} day(s)',
    fortunePrizeDaysDemo: '{days} day(s) of demo subscription',
    fortunePrizeDaysReal: '{days} day(s) of real subscription',
    fortunePrizeMoney: '${usd} in Telegram Stars',
    fortunePrizeWhereMoney: '+${usd} · {stars} ⭐ to your Telegram balance',
    fortunePrizeWhereDays: '{account} subscription extended by {days} day(s)',
    fortuneAccountDemo: 'Demo',
    fortuneAccountReal: 'Real',
    fortunePaidHint: 'Money prizes are credited in Telegram Stars to your balance. Subscription days are added to your current plan.',
    fortuneNoBalance: 'The star balance is shown in the Telegram payment window.',
    fortuneProcessing: 'Opening payment…',
    fortuneWaiting: 'Waiting for payment…',
    fortuneSpinning: 'Spinning…',
    fortuneWin: 'You won',
    fortuneYourPrize: 'YOUR PRIZE',
    fortuneWinMoney: '${usd} in Telegram Stars',
    fortuneWinSub: '{days} day(s) of {kind} subscription',
    fortuneWinPending: 'The stars will be credited to your Telegram balance shortly.',
    fortunePickLabel: 'Choose a wheel',
    fortuneStarNoteBold: 'Tapping the button charges nothing',
    fortuneStarNoteTail: '. Stars are charged only after you confirm the payment in the Telegram window.',
    fortunePriceLabel: 'Spin',
    fortuneLegendDays: 'Won days are applied immediately — the subscription appears even if you did not have one.',
    fortuneLegendMoney: 'Money arrives as Telegram Stars on your balance — ≈ {stars} ⭐ per $1.',
    fortuneHistory: 'My winnings',
    fortuneHistoryLink: 'Winnings history',
    fortuneHistorySub: 'last {days} days',
    fortuneHistoryBack: 'Back to the wheel',
    fortuneHistoryEmpty: 'No spins yet.',
    fortuneHistoryEmptyTitle: 'Nothing yet',
    fortuneHistoryEmptyText: 'Your prizes will appear here. The first one — right after a spin.',
    fortuneHistoryPending: 'Stars on the way',
    fortuneHistoryPaid: 'Credited',
    fortuneHistoryDone: 'Credited',
    fortuneKindDemo: 'demo',
    fortuneKindReal: 'real',
    fortuneCanvasDay: 'd',
    fortuneCanvasDemo: 'demo',
    fortuneCanvasReal: 'real',
    fortuneClose: 'Close',
    fortuneSpinAgain: 'Spin again',
    fortuneLoadError: 'Could not load the fortune wheel. Try again later.',
    fortuneInvoiceError: 'Could not create the payment invoice. Try again.',
    fortuneNotInTelegram: 'Open the app in Telegram to pay with Stars.',
    fortuneDisabled: 'The fortune wheel is temporarily unavailable.',
    fortuneLatePaid: 'The payment went through, but the prize is still being recorded. Check your winnings in a minute.',
    fortuneConfirmHint: 'The payment is charged only after your confirmation in the Telegram window.',
  },

  ru: {
    // Nav / Header
    dashboard:   'Главная',
    portfolio:   'Биржи',
    bots:        'Торговля',
    trading:     'Дневник',
    admin:       'Админ',

    // Админ-панель (базовый слой)
    adminConfig: 'Конфиг приложения',
    adminMaintenance: 'Тех. работы',
    adminMaintenanceHint: 'Когда включено — все пользователи видят экран «Тех. работы», API отвечает 503.',
    adminExchanges: 'Биржи',
    adminExchangesHint: 'Показывать/скрывать биржи в приложении.',
    adminPayments: 'Способы оплаты',
    adminPaymentsHint: 'Показывать/скрывать сети приёма оплаты.',
    adminFeatures: 'Разделы приложения',
    adminFeaturesHint: 'Включать/выключать разделы.',
    adminBroadcast: 'Рассылка',
    adminBroadcastHint: 'Отправить сообщение всем пользователям.',
    adminBroadcastTitle: 'Рассылка сообщения',
    adminBroadcastPlaceholder: 'Текст сообщения…',
    adminBroadcastBtn: 'Отправить',
    adminBroadcastSending: 'Отправка…',
    adminBroadcastConfirm: 'Отправить это сообщение всем пользователям? Бот доставит его каждому из них.',
    adminBroadcastDone: 'Рассылка запущена: {n} пользователей',
    adminBroadcastNote: 'Сообщение появится в чате бота у каждого активного пользователя.',
    adminNotifications: 'Уведомления админу',
    adminNotifEnabled: 'Уведомления включены',
    adminNotifRegister: 'Новая регистрация',
    adminNotifPayment: 'Оплата / продление',
    adminNotifExpiry: 'Истечение подписки',
    adminNotifChatId: 'Telegram chat / группа для уведомлений',
    adminNotifChatPlaceholder: 'напр. 123456789',
    adminSave: 'Сохранить',
    adminSaved: 'Конфиг сохранён',
    adminLoadError: 'Не удалось загрузить конфиг',
    adminSaveError: 'Не удалось сохранить конфиг',
    adminOnly: 'Только для админа',
    adminSubs: 'Подписки',
    adminSubsHint: 'Поиск пользователя по ID, управление подпиской, проверка оплат по хэшу транзакции.',
    adminSubsSearchTitle: 'Поиск пользователя по ID',
    adminSubsSearchPlaceholder: 'ID пользователя',
    adminSubsSearchBtn: 'Найти',
    adminSubsNotFound: 'Пользователь не найден',
    adminSubsUser: 'Пользователь',
    adminSubsSubActive: 'Подписка активна',
    adminSubsSubInactive: 'Подписки нет',
    adminSubsPlan: 'Тариф',
    adminSubsExpires: 'До',
    adminSubsDemo: 'Демо',
    adminSubsHistory: 'История оплат',
    adminSubsHistoryEmpty: 'Оплат пока нет',
    adminSubsExtendLabel: 'Продлить (дней)',
    adminSubsExtendBtn: 'Продлить',
    adminSubsDaysPlaceholder: 'напр. 30',
    adminSubsKindLabel: 'Дни какого счёта',
    adminSubsKindAuto: 'как сейчас (не менять тип)',
    adminSubsKindReal: 'реальный счёт',
    adminSubsKindDemo: 'демо-счёт',
    adminSubsCancelBtn: 'Аннулировать подписку',
    adminSubsCancelConfirm: 'Полностью аннулировать подписку этого пользователя? Его активные заявки на оплату будут закрыты.',
    adminSubsAddLabel: 'Добавить другую подписку',
    adminSubsAddBtn: 'Добавить подписку',
    adminSubsActivateTitle: 'Ручная активация',
    adminSubsActivateHint: 'Выдать тариф вручную, например после проверки оплаты по хэшу.',
    adminSubsSelectPlan: 'Тариф',
    adminSubsVerifyTitle: 'Проверка по хэшу транзакции',
    adminSubsVerifyHint: 'Проверить в сети, что USDT пришли на один из наших кошельков. Можно указать адрес кошелька-получателя, чтобы сузить поиск.',
    adminSubsNetwork: 'Сеть',
    adminSubsTxPlaceholder: 'Хэш транзакции',
    adminSubsAddrLabel: 'Адрес кошелька',
    adminSubsAddrPlaceholder: 'Адрес кошелька (необязательно)',
    adminSubsCheckBtn: 'Проверить хэш',
    adminSubsCheckBusy: 'Проверка…',
    adminSubsResultFound: 'Платёж найден',
    adminSubsResultNotFound: 'Платёж не найден',
    adminSubsResultAmount: 'Сумма',
    adminSubsResultFrom: 'Отправитель',
    adminSubsResultTo: 'Получатель',
    adminSubsResultConfirmed: 'Подтверждено',
    adminSubsResultNote: 'Примечание',
    adminSubsConfirmActivate: 'Подтвердить подписку',
    adminSubsActivated: 'Подписка активирована',
    adminSubsExtended: 'Подписка продлена',
    adminSubsCancelled: 'Подписка аннулирована',
    adminSubsError: 'Запрос не выполнен',
    adminSubsPayPending: 'Ожидает',
    adminSubsPayPaid: 'Оплачено',
    adminSubsPayExpired: 'Истекла',
    adminSubsPayFailed: 'Ошибка',
    adminSubsPayCancelled: 'Отменена',
    adminStats: 'Статистика',
    adminStatsHint: 'Выручка, пользователи и воронка оплат.',
    adminUtm: 'UTM',
    adminUtmHint: 'UTM-ссылки и источники трафика.',
    statRevenue: 'Выручка',
    statRevenueTotal: 'Общая выручка',
    statRevenueMonth: 'За текущий месяц',
    statRevenueWeek: 'За 7 дней',
    // Показывается, когда в «Финансах» нажат сброс статистики: выручка тоже
    // считается от метки сброса (см. resetFinanceStats в TG-BOT/src/db.js).
    statRevenueReset: 'Считается с момента сброса статистики в «Финансах»: {at}',
    statByPlan: 'По тарифам',
    statByNetwork: 'По сетям',
    statCountSuffix: 'оплат',
    statUsers: 'Пользователи',
    statUsersTotal: 'Всего зарегистрировано',
    statUsersActive: 'Активны сейчас',
    statSeenToday: 'Заходили сегодня',
    statSeen7d: 'Заходили за 7 дней',
    statSeen30d: 'Заходили за 30 дней',
    statWithApiKeys: 'Подключили биржу (API-ключи)',
    statWithBots: 'Создали ботов',
    statOnDemo: 'На демо-счёте',
    statOnReal: 'На реальном счёте',
    statFunnel: 'Посмотрели, но не дошли до оплаты',
    statViewedApp: 'Посмотрели приложение / бот',
    statNotReachedPayment: 'Вошли, но не доходили до оплаты',
    statStartedNotPaid: 'Начали оплату, но не оплатили',
    statEverPaid: 'Платили хотя бы раз',
    statNoSubscription: 'Сейчас без подписки',
    utmGenerator: 'Генератор ссылок',
    utmGenHint: 'Выбери источник, канал и кампанию — получишь готовую ссылку. Кто откроет её — попадёт в статистику ниже.',
    utmSource: 'Источник (utm_source)',
    utmSourcePlaceholder: 'telegram, google, partner…',
    utmMedium: 'Канал (utm_medium)',
    utmMediumPlaceholder: 'cpc, banner, referral…',
    utmCampaign: 'Кампания (utm_campaign)',
    utmCampaignPlaceholder: 'launch, friend…',
    utmLinkTelegram: 'Ссылка для Telegram',
    utmLinkWeb: 'Веб-ссылка',
    utmCopy: 'Копировать',
    utmCopied: 'Скопировано ✓',
    utmOpen: 'Открыть',
    utmBotHint: 'Бот: {name} — под него собраны ссылки. Если бота переименуют — обновятся сами.',
    utmGenNote: 'Telegram-ссылка открывает бота и несёт метки внутри стартового параметра — вставляй её в описание YouTube, посты, чаты или рекламу. Веб-ссылка — для сайтов и прямого трафика.',
    utmStats: 'Статистика переходов',
    utmTotal: 'Юзеров с метками',
    utmBySource: 'По источникам',
    utmByCampaign: 'По кампаниям',
    utmSubscribers: 'подписаны',
    utmRecent: 'Свежие переходы',
    utmRecentEmpty: 'Пока меток нет — никто не открывал приложение по UTM-ссылке.',
    utmInternalNote: 'Внутренние аккаунты (владелец и тестовый юзер «режима юзера») в статистику не входят — их собственные заходы не учитываются.',
    utmError: 'Не удалось загрузить статистику UTM',
    utmDynamics: 'Динамика по дням',
    utmDynHint: 'Сколько юзеров пришло по меткам за последние {days} дней и сколько из них оплатило.',
    utmDynUsers: 'пришло',
    utmDynPaid: 'оплатили',
    utmByMedium: 'По каналам (utm_medium)',
    utmDynEmpty: 'За период данных пока нет.',
    utmTerm: 'Ключ (utm_term)',
    utmTermPlaceholder: 'keywords, ad set…',
    utmContent: 'Контент (utm_content)',
    utmContentPlaceholder: 'banner, post, video…',
    utmPresets: 'Быстрые пресеты',
    utmPresetTg: 'Telegram',
    utmPresetGoogle: 'Google',
    utmPresetFb: 'Facebook',
    utmPresetIg: 'Instagram',
    utmPresetTt: 'TikTok',
    utmPresetPartner: 'Партнёр',
    utmByEntry: 'По точке входа',
    utmRevenue: 'выручка',
    utmRevenueTotal: 'Выручка с юзеров по меткам',
    utmDays: '{days} дн.',
    supportCooldown: 'Вы уже отправляли обращение. Следующее можно отправить через {min} мин.',
    maintenanceTitle: 'Ведутся технические работы',
    maintenanceText: 'Мы обновляем сервис. Пожалуйста, зайдите через несколько минут.',

    // UserProfile
    subscriptionUntil: 'Подписка до:',
    subscriptionInactive: 'Подписка не активна',
    adminNoExpiry: 'Админ · без срока',
    userFallback: 'Пользователь',
    subscription: 'Подписка',
    extendSubscription: 'Продлить подписку',
    subscriptionSelectPlanDesc: 'Выберите подходящий тарифный план:',
    // Юридические дисклеймеры (Волна 0.3, 2026-08-31): риск-дисклеймер на
    // экране подписки, «не финансовый совет» + ToS/Privacy + 18+ в футере.
    legalFooter: 'Не является финансовым советом · 18+',
    legalTerms: 'Условия',
    legalPrivacy: 'Конфиденциальность',
    legalTitle: 'Правовая информация',
    legalRiskDisclaimer: 'Криптовалютная торговля связана с высоким риском. Бот не гарантирует прибыль. Вы можете потерять весь депозит.',
    legalNotFinancialAdvice: 'Это не финансовый совет. Сервис предоставляется в информационных целях. Ничто в приложении не является рекомендацией покупать или продавать какие-либо активы.',
    legal18Plus: 'Приложение предназначено для пользователей старше 18 лет. Продолжая использовать сервис, вы подтверждаете, что вам исполнилось 18 лет.',
    legalTosTitle: 'Условия использования',
    legalTosBody: '• Сервис предоставляет торговых ботов для сбора фандинга на криптобиржах.\n• Используя сервис, вы принимаете риски торговли криптоактивами и несёте полную ответственность за свои средства.\n• Вы несёте ответственность за сохранность своих API-ключей и средств на бирже.\n• Администрация может изменить или прекратить работу сервиса с предварительным уведомлением.\n• Запрещено нарушение работы сервиса и попытки несанкционированного доступа.',
    legalPrivacyTitle: 'Политика конфиденциальности',
    legalPrivacyBody: '• Мы обрабатываем минимально необходимые данные: ваш Telegram-идентификатор, имя и настройки приложения.\n• Ваши API-ключи бирж хранятся зашифрованными и используются только для торговли.\n• Мы не передаём ваши персональные данные третьим лицам, кроме случаев, предусмотренных законом.\n• Вы можете запросить удаление своих данных через поддержку.',
    // Блок «Безопасность API-ключей» (task.txt, 2026-09-16): успокаивающие пункты
    // про ключи — каждый факт подтверждён кодом (AES-256-GCM, маска, память, админ).
    legalSecurityTitle: 'Безопасность API-ключей',
    legalSecurityBody: '🔐 Ключи шифруются по стандарту AES-256-GCM при сохранении — в открытом виде они не хранятся нигде.\n🕶 Полный ключ нигде в приложении не показывается — видны только первые и последние 4 символа (маска).\n🧠 Ключи расшифровываются только в памяти торгового процесса на время сделки и не записываются на диск и в логи.\n👤 Администрация не видит ваши ключи в открытом виде — полный ключ недоступен даже в панели управления.\n🗑 Ключи можно удалить в любой момент: торговля бота остановится, сохранённые ключи будут удалены.\n🔒 Ключи дают доступ ТОЛЬКО к торговле фьючерсами на бирже — у торговых API-ключей нет права снятия средств, поэтому вывести деньги с вашего счёта по таким ключам невозможно.\n🔀 Ключи каждой биржи изолированы: Bybit-ключи используются только для сделок Bybit, Binance — только для Binance, Bitget — только для Bitget.\n⏳ Ключи используются исключительно в момент сделки (выставление ордера, контроль позиции, её закрытие) и больше ни для чего.\n🧹 Удаление ключа мгновенно стирает его (и парольную фразу, если она задана) из базы — после удаления ключ восстановить нельзя.',
    // Условия реферальной программы (п.4.4 ПЛАН_МАРКЕТИНГА) — блок «Условия» (внизу
    // мини-аппа), после Политики конфиденциальности, как просил владелец.
    legalReferralTitle: 'Реферальная программа',
    legalReferralBody: '• Вы приглашаете друзей по своей персональной ссылке.\n• Вы получаете 10% от суммы ПЕРВОЙ оплаченной подписки друга.\n• «Друг» — новый пользователь, который ни разу не оплачивал подписку. Каждый друг учитывается один раз.\n• Вознаграждение накапливается в USD и выплачивается вручную до 5-го числа месяца, следующего за оплатой друга.\n• Нельзя приглашать самого себя.\n• Администрация может изменить или прекратить программу в любой момент.',
    // Онбординг первого входа (п.0.3, 2026-08-31): 3 экрана → пробный бот.
    onbTitle: 'Торговый бот забирает выплаты фандинга: каждые 8 часов, а у части монет — каждый час',
    onbSubtitle: 'Бесплатный пробный бот: без API-ключей и без подписки. Торгует на реальных данных рынка — первые 2 сделки в подарок.',
    onbCta: 'Попробовать бесплатно',
    onbLater: 'Позже',
    onbCreating: 'Создаём пробного бота...',
    onbCreatingHint: 'Это бесплатно и займёт несколько секунд',
    onbCreateFailed: 'Не удалось создать пробного бота. Попробуйте ещё раз.',
    onbRetry: 'Повторить',
    trialStatusTitle: 'Пробный бот',
    trialStatusStartDesc: 'Пробный бот создан. Запустите его, чтобы начать ловить выплаты фандинга.',
    trialStatusStart: 'Запустить',
    trialStatusRunning: 'Пробный бот запущен и ждёт выплату фандинга',
    trialStatusWaiting: 'Бот ждёт выплату фандинга. Как только выплата придёт — бот войдёт в сделку.',
    trialStatusViewBot: 'Открыть бота',
    planDemo: 'Демо-счёт (1 месяц)',
    plan1Month: 'Реальный счёт (1 месяц)',
    plan3Months: 'Реальный счёт (3 месяца)',
    plan6Months: 'Реальный счёт (6 месяцев)',
    continue: 'Продолжить',
    back: 'Назад',
    completePayment: 'Оплата',
    subscriptionSendPaymentDesc: 'Отправьте точную сумму на адрес ниже:',
    amountToSend: 'Сумма к отправке',
    walletAddress: 'Адрес кошелька',
    copy: 'Копировать',
    copied: 'Скопировано!',
    subscriptionWarning: 'Важно: Отправляйте только указанную валюту в указанной сети. Отправка других активов может привести к безвозвратной потере средств.',
    confirmPayment: 'Я отправил платёж',
    // Subscription payment (real crypto flow)
    createPayment: 'Создать платёж',
    creatingPayment: 'Создаём платёж…',
    paymentExpiresIn: 'Платёж действителен 20 минут',
    paymentWindowLeft: 'Осталось',
    paymentPending: 'Ожидание оплаты…',
    checkPayment: 'Проверить оплату',
    paymentConfirmed: '✅ Оплата подтверждена!',
    paymentActivated: 'Подписка активирована.',
    paymentExpired: '⏰ Время оплаты истекло. Пожалуйста, создайте новый платёж.',
    paymentCreateFailed: 'Не удалось создать платёж.',
    noFreeAddress: 'Сейчас нет свободного адреса для приёма в этой сети. Выберите другую сеть или попробуйте позже.',
    rateUnavailable: 'Курс временно недоступен. Попробуйте через несколько минут.',
    planRealHint: 'Включает доступ к демо-счёту',
    planDemoHint: 'Только демо-счёт',
    planIncludesArb: 'Включает арбитраж-бот',
    paymentChecking: 'Проверяем платёж…',
    paymentStillPending: 'Платёж пока не обнаружен в сети. Обычно он появляется в течение нескольких минут — подождите, проверка продолжится автоматически.',
    paymentCheckFailed: 'Не удалось проверить платёж. Попробуйте ещё раз через несколько секунд.',
    paymentCheckFailedDetail: 'Не удалось проверить платёж: {error}. Попробуйте ещё раз через несколько секунд.',
    processingTitle: 'Оплата в обработке',
    processingCheck: 'Мы проверяем поступление вашего платежа в сети. Обычно это занимает до минуты — подождите.',
    processingCancelHint: 'Отмена закроет это окно и вернёт вас к шагу оплаты.',
    closeWindowConfirmTitle: 'Закрыть это окно?',
    closeWindowConfirmMsg: 'Вы вернётесь к шагу оплаты. Заявка на оплату останется активной, проверка продолжится.',
    closeWindow: 'Закрыть',
    subInfoAmount: 'Сумма',
    subInfoNetwork: 'Сеть',
    subInfoPlan: 'Тариф',
    subInfoValidUntil: 'Действует до',
    supportContact: 'Написать в поддержку',
    supportExpired: 'Время оплаты истекло. Если вы уже отправили платёж — напишите в поддержку, мы проверим.',
    supportTitle: 'Связаться с поддержкой',
    supportIntro: 'Выберите проблему или опишите её — сообщение автоматически отправится в наш чат поддержки.',
    supportOpt1: 'Я оплатил, но платёж не зачислился',
    supportOpt2: 'Вопрос по подписке (тариф, продление, оплата)',
    supportOpt3: 'Другое',
    supportPlaceholder: 'Опишите проблему… (необязательно)',
    supportSend: 'Открыть Telegram и отправить',
    supportCopied: 'Сообщение скопировано — вставьте его в чат и отправьте.',
    supportMsgHello: 'Здравствуйте! У меня проблема с оплатой подписки:',
    supportMsgUser: 'Пользователь',
    supportMsgRequest: 'Заявка',
    supportMsgAddress: 'Адрес',
    supportMsgAmount: 'Сумма',
    supportMsgProblem: 'Проблема',
    supportMsgDetails: 'Подробности',
    supportMsgGeneralHello: 'Здравствуйте! У меня вопрос к поддержке:',
    supportSending: 'Отправляем…',
    supportSentOk: '✅ Сообщение отправлено! Ответ придёт в чат с ботом SCALPEX.',
    supportSendFail: '⚠️ Не удалось отправить. Попробуйте ещё раз или напишите в чат поддержки напрямую.',
    cancelPayment: 'Отменить платёж',
    cancel: 'Отмена',
    cancellingPayment: 'Отменяем…',
    cancelPaymentConfirmTitle: 'Отменить платёж?',
    cancelPaymentConfirmMsg: 'Если вы уже отправили средства на этот адрес — они не будут зачислены. Отменить?',
    cancelPaymentFailed: 'Не удалось отменить платёж.',

    // Time period tabs
    periodDaily:   'День',
    periodWeekly:  'Неделя',
    periodMonthly: 'Месяц',
    periodTotal:   'Всего',

    // Stats cards
    statToday:      'Сегодня',
    statYesterday:  'Вчера',
    statDifference: 'Разница',

    // KPI
    tradingStats:     'Статистика торговли',
    kpiWinRate:       'Процент побед',
    kpiTotalTrades:   'Сделок всего',
    kpiAvgProfit:     'Ср. профит',
    kpiProfitFactor:  'Профит-фактор',
    kpiMaxDrawdown:   'Макс. просадка',
    kpiTopAssets:     'Топ 3 актива',

    // Profit section
    profit: 'Профит',

    // Profit section tooltip
    profitTooltip: 'Отображается реализованный профит / убыток — учитываются только закрытые позиции.',

    // Settings modal
    settingsTitle:      'Настройки',
    languageLabel:      'Язык',
    notificationsLabel: 'Уведомления',
    save:               'Сохранить',

    // Реферальная программа (п.4.4 ПЛАН_МАРКЕТИНГА) — блок в Настройках
    settingsReferralLabel: 'Реферальная программа',
    referralInviteTo:      'Пригласи друга — получи 10% от его первой подписки.',
    referralLinkLabel:     'Ваша ссылка-приглашение',
    referralFriendsInvited:'Приглашено друзей',
    referralTotalEarned:   'Заработано всего',
    referralEarnedMonth:   'Начислено в этом месяце',
    referralPayoutNote:    'Выплата — вручную, до 5-го числа следующего месяца.',
    referralDue:           'К выплате',
    referralNoFriends:     'Пока нет заработка — отправьте ссылку друзьям и получите 10% от их первой подписки.',
    referralTerms:         'Условия программы',
    referralLoading:       'Загрузка…',

    // Подсказки (обучающий тур)
    hintsLabel:          'Подсказки',
    hintsDesc:           'Проведут по приложению при первом входе. Включите заново — покажутся ещё раз.',
    welcomeHintTitle:    'Подсказки для начала работы',
    welcomeHintText:     'SCALPEX автоматизирует funding-sniping (сбор фандинга) на биржах: алгоритм находит выгодные фандинги и открывает сделки автоматически. Начните с бесплатного пробного бота — он покажет стратегию в деле без API-ключей.',
    welcomeHintCreateBot: 'Создать пробного бота',
    welcomeHintStart:    'Пройти экскурсию',
    welcomeHintDismiss:  'Подсказки можно отключить в Настройках',
    hintStep4Title:      'Пробный бот',
    hintStep4Text:       'Нажмите «Добавить бота» — если вы новый пользователь, сразу создастся бесплатный пробный бот: 2 сделки на виртуальные деньги, без API-ключей. Он покажет, как работает стратегия.',
    hintStep8Title:      'Полная инструкция',
    hintStep8Text:       'Полное руководство всегда под рукой — Настройки (шестерёнка) → Инструкция. Подсказки короткие, подробности ищите там. А сейчас создадим пробного бота.',
    hintDoneTitle:       'Всё готово!',
    hintDoneText:        'Пробный бот создан и уже торгует на виртуальные деньги — за результатами смотрите в «Дневнике». После 2 сделок можно оформить подписку и перейти на демо или реальный счёт.',
    hintNext:            'Дальше',
    hintSkip:            'Пропустить',
    hintDoneBtn:         'Готово',
    hintDisable:         'Отключить подсказки',

    // Инструкция (руководство пользователя)
    instructionTitle:    'Инструкция',
    instructionSubtitle: 'Как пользоваться ботом',
    instructionClose:    'Закрыть',
    instructionError:    'Не удалось загрузить инструкцию',
    instructionRetry:    'Повторить',
    instructionUpdated:  'Обновлено',
    welcomeHintGuide:    'Полная инструкция',

    // Гайд по API-ключам (кнопка в инструкции, Шаг 2)
    guideApiKeysTitle: 'Как получить ключи на бирже?',
    guideApiKeysError: 'Не удалось загрузить гайд',
    guideApiKeysRetry: 'Повторить',
    guideApiKeysClose: 'Закрыть',

    // Заглушка картинки инструкции (Markdown.jsx)
    imgScreenshot: 'Скриншот',
    imgNotUploaded: 'файл ещё не добавлен на сервер',

    // Exchanges page
    exchangeTitle:   'Подключение бирж',
    exchangeDesc:    'Подключите биржу через API для автоматической торговли ботами',
    connected:       'Подключено',
    notConnected:    'Не подключено',
    connect:         'Подключить',
    disconnect:      'Отключить',
    collapse:        'Свернуть',
    // 2026-09-27, task.txt. Было «Используйте Read-Only ключи для безопасности» —
    // это неверный совет: ключ только для чтения не может выставить ордер,
    // движок вызывает place_order/cancel_order, то есть ключу нужны «Чтение»
    // И «Торговля». Безопасность даёт выключенное право «Вывод средств».
    securityNote:    'В ключе включите «Чтение» и «Торговля». Право «Вывод средств» — не включайте.',
    keysGuideLink:   'Как получить ключи и какие права включить?',
    confirmConnect:  'Подтвердить подключение',
    realAccountApi:  'API реального счета',
    demoAccountApi:  'API демо-счета',

    // Bitget passphrase (2026-09-17, task.txt п.3): API v2 Bitget подписывает
    // каждый запрос фразой — для этой биржи поле обязательное.
    bitgetPassphrase: 'Парольная фраза (обязательна для Bitget)',
    bitgetPassphrasePlaceholder: 'сохранена (оставьте как есть)',
    bitgetPassphraseHint: 'Bitget API v2 требует парольную фразу (задаётся в настройках API при создании ключа). Без неё ключи не сохранятся. 8–64 символа, латиница и цифры.',

    // Notifications items
    tradingSignals:     'Торговые сигналы',
    tradingSignalsDesc: 'Уведомлять, когда бот закрыл сделку',
    // п.8 task.txt: уведомления о фандингах за 5 минут до выплаты
    fundingNotifications:     'Уведомления о фандингах',
    fundingNotificationsDesc: 'Уведомлять за 5 минут до выплаты фандинга',

    // QuickActions
    myBots: 'Мои боты',
    newBot: 'Новый бот',

    // Bots page — tabs & actions
    botsSpot:         'СПОТ',
    botsFutures:      'ФЬЮЧЕРСЫ',
    botsDisableAll:   'Выключить все',
    botsAddBot:       'Добавить бота',
    botsNoBots:       'Нет запущенных ботов',
    botsNoBotsDesc:   'Добавьте первого бота для автоматической торговли',
    botsNoBotsHint:   'Добавьте первого бота для автоматической торговли',
    // ── Пробный виртуальный бот (Волна 1, 2026-08-28) ──
    virtualBadge:            'ПРОБНЫЙ',
    virtualCreateHint:       'Пробный бот бесплатно · 2 сделки, без API-ключей',
    virtualTrialFinishedTitle: 'Пробный период завершён',
    virtualTrialFinishedDesc: 'Пробный бот исчерпал 2 бесплатные сделки. Оформите подписку, чтобы продолжить — демо или реальный счёт.',
    virtualSubscribeBtn:     'Оформить подписку',
    virtualTrialCardHint:    'Демо стратегии — бот торгует виртуальными деньгами.',
    botsInDev:        'В разработке',
    botsInDevDesc:    'Боты для арбитража скоро появятся. Следите за обновлениями!',
    botsExchangeTaken:'Бот на этом счёте уже создан',
    botsExchangeUnavailable:'Эта биржа недоступна для новых ботов',
    botsPairTaken:    'Бот для этой пары уже существует',
    createDemoBot:    'Создать демо-бота',
    createRealBot:    'Создать реального бота',
    botsAllCreated:   'У вас уже созданы боты для всех доступных типов счёта на всех биржах',
    botsNoSubscriptionHint: 'Вы достигли лимита ботов по вашим подпискам. Чтобы создать еще одного бота, активируйте подписку на другой тип счета.',

    // Bot toggle
    botToggleOn:     'ВКЛ',
    botToggleOff:    'ВЫКЛ',
    // Подписка истекла — ползунок заблокирован, нажатие показывает это уведомление
    botSubExpired:   'Ваша подписка истекла. Продлите её в разделе «Подписка», чтобы снова запустить бота.',
    botSubExpiredBanner: 'Ваша подписка истекла — боты остановлены. Продлите подписку, чтобы включить их.',

    // Bot card info rows
    botType:         'Тип бота',
    botBalance:      'Рабочий объём',
    botClosedTrades: 'Закрытых сделок',
    botCommission:   'Комиссия биржи',
    botProfit:       'Прибыль от сделок',
    botStatus:       'Статус',
    botStatusActive: 'Включён',
    botStatusPaused: 'Выключен',
    botOpenPos:      'Откр. позиции',
    botCreated:      'Дата создания',
    botExchange:     'Биржа',

    // Понятная юзеру ошибка по боту. Категорию (kind) присылает бэкенд
    // (botHealth) в поле problem — тексты живут здесь, чтобы работали оба
    // языка. Юзеру не показываем ни кодов биржи, ни её JSON: только эти фразы.
    botProblemVolume:        'Ошибка торгового объёма',
    botProblemVolumeAdvice:  'Биржа не принимает сделки: объём слишком большой для денег на торговом счёте. Уменьшите объём или пополните торговый счёт.',
    botProblemNoFunds:       'Не хватает денег на торговом счёте',
    botProblemNoFundsAdvice: 'Переведите деньги со счёта пополнения на торговый счёт внутри биржи (инструкция, Шаг 3) либо уменьшите объём сделки или плечо в настройках бота. Бот открывает несколько сделок сразу — свободной маржи должно хватать на все.',
    botProblemApiKey:        'Проблема с API-ключом',
    botProblemApiKeyAdvice:  'Проверьте ключ: права на торговлю и IP-адрес (инструкция, Шаг 2).',
    botProblemSymbol:        'Проблема с монетой',
    botProblemSymbolAdvice:  'Монета недоступна или объём меньше минимального лота биржи. Бот попробует другие монеты.',
    botProblemOther:         'Биржа не принимает сделки',
    botProblemOtherAdvice:   'Проверьте деньги на торговом счёте и настройки бота.',

    // Bot delete flow
    botStopFirst:    'Сначала остановите бота',
    botConfirmDel:   'Удалить этого бота?',
    botConfirmDelMsg:'Если есть открытые позиции — бот немедленно закроет их, после чего удалится.',
    botDelete:       'Удалить',
    botCancel:       'Отмена',
    botNameExists:   'Бот с таким именем уже существует',

    // Exchanges
    edit:            'Изменить',
    delete:          'Удалить',
    editApiKeys:     'Введите новые API ключи для обновления подключения',
    saveChanges:     'Сохранить изменения',

    // Diary
    diaryTotalIncome:'Общий доход',
    diaryClearConfirmTitle: 'Очистить дневник?',
    diaryClearConfirmMsg: 'Боты должны быть удалены перед очисткой дневника.',
    diaryClearAction: 'Очистить',
    diaryClearCancel: 'Отмена',

    // Add bot modal
    addBotTitle:      'Добавить бота',
    addBotName:       'Название бота',
    addBotNamePh:     'Мой бот',
    addBotNameEn:     'Название бота — только английские буквы, цифры и пробелы',
    addBotExchange:   'Биржа',
    addBotVolume:     'Доступный объём (USDT)',
    addBotAlgoTitle:  'Параметры алгоритма',
    addBotLeverage:   'Плечо',
    addBotOrders:        'Количество фандингов',
    orderLabel:          'Ордер',
    addBotOrderOffset:   'Отступ (%)',
    addBotOrderVolume:   'Объём (USDT)',
    addBotTakeProfit:    'Тейк-профит (%)',
    tooltipTakeProfit:   'Тейк-профит здесь — не цель по прибыли, а просто точка выхода. Его устанавливают минимальным, чтобы быстро выйти из позиции после получения выплаты по фандингу: смысл стратегии — забрать фандинг и закрыться, не потеряв на движении цены.',
    // SHORT-режим: тейк-профит — уровень падения цены ниже фандинга (task.txt).
    // При фандинге −1% цена должна упасть на 1% (покрыть нашу выплату), всё ниже — прибыль.
    // Итог = 1% (выплата фандинга) + 0,3% (наш тейк-профит) = 1,3%.
    tooltipTakeProfitShort: 'В режиме SHORT тейк-профит — это уровень, ниже которого должна упасть цена после выплаты фандинга. Если фандинг −1%, цена должна упасть на 1% (чтобы покрыть нашу выплату фандинга), а всё, что ниже, — наша прибыль. Итог: тейк-профит = 1% (выплата фандинга) + 0,3% (наша прибыль) = 1,3%.',
    addBotStopLoss:      'Стоп-лосс (%)',
    tooltipStopLoss:     'Стоп-лосс — это убыток, который вы можете получить, если ситуация не сработает как надо. По сути, страховка от неожиданного движения цены.',
    addBotLaunch:        'Создать бота',
    addBotBlacklistTitle:'Чёрный список пар',
    addBotBlacklistDesc: 'Пары из списка не будут отрабатываться Ботом',
    addBotBlacklist:     'Игнорируемые пары',
    addBotBlacklistPh:   'Поиск пары (напр. BTCUSDT)...',
    tooltipOrders:       'Количество фандингов, которые бот будет отрабатывать. Если задано 3 и под фильтр подходят 3 фандинга — по каждому откроется позиция и каждый будет отработан.',
    addBotGlobalVolume:  'Объём (USDT)',
    tooltipGlobalVolume:      'Объём задаётся для одной сделки по одному фандингу (одной отработке).',
    tooltipGlobalVolumePart2: 'Если количество фандингов равно 3, бот возьмёт этот же объём для каждой сделки отдельно — указанная вами сумма применится к каждому фандингу.',
    addBotVolumeMin:     'Минимальный объём — 10 USDT',
    addBotMinFunding:    'Мин. ставка финансирования',
    tooltipMinFunding:   'Бот фильтрует фандинги: значение — верхняя граница. В работу идут монеты со ставкой НЕ ВЫШЕ указанной. Минус уже стоит в поле — введите только цифру: 0.6 означает -0.6% (чем ставка отрицательнее, тем больше выплата в лонг).',
    addBotMaxFunding:    'Макс. ставка финансирования',
    tooltipMaxFunding:   'Необязательно. Нижний предел ставки: монеты со ставкой НИЖЕ указанной не отрабатываются. Минус уже стоит в поле — введите 1.0, чтобы это означало -1.0%, и бот брал фандинги в диапазоне от -1.0% до вашего минимума. Пусто — без ограничения.',
    addBotTradingMode:   'Настройки параметров',
    tradingModeDesc:     'Режим «Пользовательские» — для тех, кто хорошо разбирается в алгоритме и стратегии: здесь можно экспериментировать и корректировать различные параметры. Обычным пользователям его включать не рекомендуется — всё уже настроено так, чтобы бот торговал в плюс.',
    addBotTradeDir:      'Направление сделки',
    recommendedMode:     'Рекомендуется',
    tradeModeLong:       'Long · сбор фандинга',
    tradeModeShort:      'Short · сбор падений',
    tradeModeLongDesc:   'Бот открывает ЛОНГ-позицию перед выплатой фандинга и забирает саму выплату: при глубоко отрицательной ставке (≤ −0.6%) шортисты платят лонгистам. Классический режим сбора фандинга.',
    tradeModeShortDesc:  'Бот открывает ШОРТ-позицию и забирает движение (падение/откат), которое происходит после выплаты фандинга. Полное объяснение режима — в инструкции.',
    tradingModeSafe:     'Пользовательские',
    tradingModeAggressive: 'Агрессивные',

    // task.txt №3 (2026-09-04): одноразовое уведомление о смене рекомендуемого
    // режима (появляется по центру, показывается один раз на каждую смену).
    modeNoticeTitle:     'Рекомендуемый режим ботов',
    modeNoticeTextShort: 'Волатильность выросла, рынок снижается. Для таких условий рекомендуем режим ШОРТ.',
    modeNoticeTextLong:  'Сложились благоприятные условия для сбора фандинга. Рекомендуем режим ЛОНГ.',
    modeNoticeDismiss:   'Понятно',

    // Bots main tabs
    botsTabSignals:    'Сигналы',
    botsTabActiveBots: 'Активные боты',
    botsTabConfig:     'Конфигурация',

    // Signals
    signalPinned:          'ЗАКРЕПЛЁН',
    signalsComingSoon:     'Нет сигналов',
    signalsComingSoonDesc: 'Нет пар, соответствующих текущей конфигурации. Измените время или минимальную ставку.',
    signalLaunched:        'Бот добавлен!',
    signalNoResults:       'Нет сигналов',
    signalNoResultsDesc:   'Нет пар, подходящих под фильтр. Измените время или минимальную ставку в Конфигурации.',
    signalsLoadError:      'Не удалось загрузить сигналы. Проверьте соединение.',

    // ── Захардкоженные строки перенесены в i18n (2026-08-05) ──
    timeMin: 'м',
    timeHour: 'ч',
    loading: 'Загрузка...',
    creating: 'Создание...',
    processing: 'Обработка...',
    connectionError: 'Ошибка соединения с сервером',
    alertErrorPrefix: 'Ошибка',
    unknownError: 'Неизвестная ошибка',
    funding: 'Фандинг',
    accountMode: 'Режим счета',
    realKeysLocked: '🔒 Ключи реального счета требуют подписку «Реальный счет»',
    demoKeysLocked: '🔒 Ключи демо-счета требуют активную подписку',
    realAccountLocked: '🔒 Реальный счет требует подписку «Реальный счет»',
    demoAccountLocked: '🔒 Демо-счет требует активную подписку',
    // Слот бота — пара «тип счёта × биржа» (2026-09-20): демо-бот на Bybit не
    // мешает создать демо-бота на Binance, поэтому подпись говорит, НА КАКОЙ
    // бирже слот занят ({exchange} подставляется в AddBotModal), а отдельная
    // строка — случай, когда заняты все биржи.
    demoBotExists: '🔒 На бирже {exchange} демо-бот уже создан — выберите другую биржу',
    realBotExists: '🔒 На бирже {exchange} реальный бот уже создан — выберите другую биржу',
    demoBotAllExchanges: '🔒 Демо-бот уже создан на всех биржах — удалите его, чтобы создать нового',
    realBotAllExchanges: '🔒 Реальный бот уже создан на всех биржах — удалите его, чтобы создать нового',
    tradingModeCustom: 'Пользовательские',
    tradingModeSystem: 'Системные',
    initEnv: 'Инициализация(~4мин.)',
    initProgress: 'Инициализация...',
    noApiKeysHint: '🔑 Сначала подключите API ключи биржи в разделе «Биржи»',
    botsLimitReached: 'Достигнут лимит {n}/{n} ботов',
    botsLoadError: 'Не удалось загрузить ботов. Проверьте соединение.',
    signalLaunchError: 'Не удалось создать бота. Проверьте соединение.',
    configSaveError: 'Не удалось сохранить конфигурацию',
    blacklistSaveError: 'Ошибка сохранения блэклиста',
    inDevelopment: 'В разработке',
    soon: 'Скоро',
    networkSelectTitle: 'Выберите сеть',
    selectNetworkForUsdt: 'Выберите сеть для USDT:',
    notViaTelegram: '❌ Приложение открыто не через Telegram — window.Telegram.WebApp недоступен',
    // Telegram Stars — «Покупка в один клик» (план 2026-09-05). Наценки нет;
    // строка о комиссии Telegram юзеру НЕ показывается (решение владельца).
    starsQuickTitle: 'Покупка в один клик',
    starsQuickDesc: 'Быстрая, удобная оплата',
    starsBuy: 'Оплатить {stars} ⭐ в один клик',
    starsPaid: 'Подписка активна 🎉',
    starsProcessing: 'Оплачиваю…',
    starsActivating: 'Оплачено — активирую подписку',
    starsInvoiceError: 'Не удалось открыть счёт. Попробуйте ещё раз.',
    starsNotInTelegram: '⭐ Оплата звёздами работает только из Telegram — откройте приложение из бота.',
    webLandingTitle: 'SCALPEX — бот для заработка на фандингах',
    webLandingSub: 'Находит подходящие ставки фандинга на Bybit и торгует за тебя прямо в Telegram. Попробуй бесплатно.',
    webLandingBtn: 'Открыть в Telegram',
    webLandingHint: 'Мини-приложение откроется прямо в Telegram — ничего устанавливать не нужно.',
    noUserId: '❌ Не удалось определить ID пользователя. Попробуйте перезапустить бота.',
    paymentSimulated: '✅ Оплата успешно смоделирована! Ваш ID добавлен в список.',
    testPaymentBtn: '🧪 Тестовая оплата (Добавить в allowed_users)',
    deleteError: 'Ошибка удаления',
    confirmDeleteKeys: 'Вы уверены, что хотите удалить сохранённые ключи?',
    keysDeleted: '✅ Ключи успешно удалены',
    integrationInDev: '🔧 Интеграция с {ex} находится в активной разработке.\nСледите за обновлениями — подключение станет доступно в ближайших версиях.',
    deleteBotToEditKeys: 'Для изменения ключей удалите бота этой биржи',
    subscriptionRequiredConnect: 'Для подключения биржи необходимо оформить подписку. Нажмите «Тестовая оплата» в разделе «Подписка».',
    diaryTotalPct: 'Общий %',
    real: 'Реальный',
    demo: 'Демо',
    refreshData: 'Обновить данные',
    diaryClearNeedDeleteBots: 'Для очистки дневника необходимо сначала удалить всех ботов',
    leaderboardTitle: '🏆 Лидерборд',
    leaderboardDays: '{n} дн.',
    // Метка своей строки: имена на доске — псевдонимы (TG-BOT/src/nickMask.js),
    // без метки юзер не узнает себя.
    leaderboardYou: 'Вы',
    // Прибыль юзера ЗА 7 ДНЕЙ — ровно то окно, по которому считает доска
    // (v6-week7, task.txt 2026-09-10), а не разовый PNL с одной сделки.
    leaderboardTotalPnl: 'Прибыль за 7 дней',
    // Депозит участника (п.25 task.txt). п.9 task.txt (2026-09-17): подпись
    // депозит»+цифра были непонятны — теперь это отдельный чип с явной меткой
    // «Депозит» и жирным значением рядом (label + value в одной строке).
    leaderboardDepositLabel: 'Депозит',
    // FOMO-блок над доской (п.11 task.txt): сколько виртуальные юзеры
    // лидерборда заработали сегодня + мини-лента последних сделок.
    fomoTitle:  '🔥 Трейдеры заработали сегодня',
    fomoRecentEarned: 'заработал {x}',
    // П.2 task.txt: когда сегодня плюсовых PNL нет — блок показывает «вчера»,
    // чтобы над доской всегда была ненулевая цифра + лента вчерашних сделок.
    fomoYesterdayTitle: '🔥 Трейдеры заработали вчера',
    // Счётчик «уже заработали сегодня» (п.28 task.txt): серая строка на Главной
    // с ротацией имён. Сумма рисуется рядом жирным (в компоненте), earnedToday —
    // только подпись до неё; {name}/{x} подставляются форматированными
    // значениями (имя частично замаскировано, x — сумма с «$»).
    earnedToday:   'Уже заработали сегодня: ',
    earnedTodayBy: '{name} {x}',
    // П.3 task.txt: когда сегодня нет плюсовых PNL — показываем «вчера заработали»,
    // чтобы строка всегда была заполнена ненулевой суммой.
    earnedYesterday:   'Вчера заработали: ',
    earnedYesterdayBy: '{name} {x}',

    // Config tab
    cfgTimeLabel:    'Время до начисления',
    cfgTimeDesc:     'Отображать только пары, у которых следующее начисление финансирования не позднее выбранного времени.',
    cfgExchangeLabel: 'Биржа',
    filterUntil:      'До начисл.',
    filterMinRate:    'Мин. ставка',
    filterPairs:      'Пар',
    cfgSaved:         'Сохранено!',

    // Bots (legacy)
    activeBots: 'Активные боты',
    botsComingSoon: 'Мои боты',

    // Diary (closed positions)
    diaryEmpty:      'Закрытых позиций нет',
    diaryLong:       'Лонг',
    diaryShort:      'Шорт',
    diaryEntry:      'Вход',
    diaryExit:       'Выход',
    diaryDuration:   'Длит-сть',
    diaryClosedAt:   'Закрыто',
    diarySize:       'Объём (USDT)',
    diaryCommission: 'Комиссия',
    diaryRoi:        'ROI',

    // Chart
    monthNames:    ['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек'],
    chartProfit:   'Профит',
    chartTrades:   'Сделок',
    chartVolume:   'Объём',
    chartWinRate:  'Win Rate',
    chartAvgPnl:   'Ср. PnL',
    chartNoData:   'Данных за этот период пока нет',

    // ComingSoon / Error
    comingSoon:      'Скоро',
    maintenance:     'Технические работы',
    maintenanceDesc: 'Мы уже устраняем неполадки. Скоро всё заработает.',
    tryAgain:        'Попробовать снова',

    // Boot (п.3 task.txt: понятный экран вместо пустого экрана при сбое загрузки)
    bootSdkFailed:     'Не удалось связаться с Telegram',
    bootSdkFailedHint: 'Проверьте соединение и откройте приложение ещё раз.',
    bootLoadFailed:    'Не удалось загрузить данные',
    bootLoadFailedHint:'Проверьте соединение и нажмите «Попробовать снова».',

    // Колесо фортуны (задача владельца 2026-10-19). Первое окно — небольшое
    // по центру с кнопкой «Забрать приз», она открывает колесо.
    fortuneIntroTitle: 'Розыгрыш бонусов',
    fortuneIntroText: 'Мы раздаём бонусы активным пользователям SCALPEX. Крутите колесо — призы от $0.50 до $30 звёздами Telegram на баланс и от 1 до 42 дней подписки.',
    fortuneIntroTake: 'Забрать приз',
    fortuneTitle: 'Колесо фортуны',
    fortuneIntroHint: 'Кнопка ничего не спишет — звёзды уйдут только после подтверждения в Telegram.',
    fortuneTierBase: 'Базовый',
    fortuneTierMid: 'Средний',
    fortuneTierAdv: 'Продвинутый',
    fortuneSpinPrice: 'Цена прокрута',
    fortuneSpin: 'Крутить',
    fortuneSpinFor: 'Крутить за {stars} ⭐',
    fortuneSpinAgainFor: 'Ещё раз · {stars} ⭐',
    // Админ крутит без списания звёзд (решение владельца 2026-10-21): путь тот
    // же, что у юзера, включая окно оплаты Telegram, но оплата не проходит.
    fortuneFreeError: 'Не удалось начать бесплатный прокрут. Попробуйте ещё раз.',
    fortuneApprox: '≈ ${usd}',
    fortunePrizesTitle: 'Призы',
    fortunePrizeDemo: 'Демо-подписка',
    fortunePrizeReal: 'Реальная подписка',
    fortunePrizeDays: '{days} дн.',
    fortunePrizeDaysDemo: '{days} дн. демо-подписки',
    fortunePrizeDaysReal: '{days} дн. реальной подписки',
    fortunePrizeMoney: '${usd} звёздами',
    fortunePrizeWhereMoney: '+${usd} · {stars} ⭐ на баланс Telegram',
    fortunePrizeWhereDays: 'Подписка на {account} счёт продлена на {days} дн.',
    fortuneAccountDemo: 'демо',
    fortuneAccountReal: 'реальный',
    fortunePaidHint: 'Денежные призы начисляются звёздами Telegram на ваш баланс. Дни подписки добавляются к текущей подписке.',
    fortuneNoBalance: 'Баланс звёзд показывается в окне оплаты Telegram.',
    fortuneProcessing: 'Открываю оплату…',
    fortuneWaiting: 'Ждём оплату…',
    fortuneSpinning: 'Крутим…',
    fortuneWin: 'Вы выиграли',
    fortuneYourPrize: 'ВАШ ПРИЗ',
    fortuneWinMoney: '${usd} звёздами Telegram',
    fortuneWinSub: '{days} дн. {kind} подписки',
    fortuneWinPending: 'Звёзды поступят на ваш баланс Telegram в ближайшее время.',
    fortunePickLabel: 'Выберите колесо',
    fortuneStarNoteBold: 'Нажатие кнопки ничего не спишет',
    fortuneStarNoteTail: '. Звёзды уйдут только после того, как вы сами подтвердите оплату в окне Telegram.',
    fortunePriceLabel: 'Прокрут',
    fortuneLegendDays: 'Выигранные дни оформляются сразу — подписка появится, даже если её ещё не было.',
    fortuneLegendMoney: 'Деньги приходят звёздами Telegram на ваш баланс — ≈ {stars} ⭐ за $1.',
    fortuneHistory: 'Мои выигрыши',
    fortuneHistoryLink: 'История выигрышей',
    fortuneHistorySub: 'последние {days} дней',
    fortuneHistoryBack: 'Назад к колесу',
    fortuneHistoryEmpty: 'Прокрутов пока нет.',
    fortuneHistoryEmptyTitle: 'Пока пусто',
    fortuneHistoryEmptyText: 'Здесь появятся ваши призы. Первый — сразу после прокрута.',
    fortuneHistoryPending: 'Звёзды в пути',
    fortuneHistoryPaid: 'Зачислено',
    fortuneHistoryDone: 'Зачислено',
    fortuneKindDemo: 'демо',
    fortuneKindReal: 'реальной',
    fortuneCanvasDay: 'дн.',
    fortuneCanvasDemo: 'демо',
    fortuneCanvasReal: 'реал',
    fortuneClose: 'Закрыть',
    fortuneSpinAgain: 'Крутить ещё',
    fortuneLoadError: 'Не удалось загрузить колесо фортуны. Попробуйте позже.',
    fortuneInvoiceError: 'Не удалось создать счёт на оплату. Попробуйте ещё раз.',
    fortuneNotInTelegram: 'Откройте приложение в Telegram, чтобы оплатить звёздами.',
    fortuneDisabled: 'Колесо фортуны временно недоступно.',
    fortuneLatePaid: 'Оплата прошла, но приз ещё записывается. Проверьте историю через минуту.',
    fortuneConfirmHint: 'Оплата спишется только после вашего подтверждения в окне Telegram.',
  },
}
